import React from 'react';
import { useNavigate } from 'react-router-dom';
import fields from './json/AssignRoomFacilitiesField.json';
import useFormChange from 'Hooks/useFormChange';
import { AssignRoomFacilitiesValidation } from 'validation/ValidationRules';
import { validateForm } from 'utils/validation';
import useFormSubmit from 'Hooks/useFormSubmit';
import { CreateAssignRoomFacilities } from 'adminApi/AssignRoomFacilitiesApi/AssignRoomFacilities';
import AssignRoomFacilitiesForm from './Components/AssignRoomFacilitiesForm';

const AssignRoomFacilities = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        AssignRoomFacilitiesValidation
    );

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => await CreateAssignRoomFacilities({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, AssignRoomFacilitiesValidation);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Room facilities assigned successfully"
    );

    return (
        <div className="col-12">
            <AssignRoomFacilitiesForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                setValues={setValues}
                title="Assign Room Facilities"
            />
        </div>
    );
};

export default AssignRoomFacilities;
